// extracted by mini-css-extract-plugin
export default {"productCarousel":"Gaa-z","itemsContainer":"Haa-z"};